/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Origin_Display_NameInputs */

const en_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const id_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const ms_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const ca_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const cs_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const da_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const de_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const et_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const es_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const fr_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const hr_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const it_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const lv_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const lt_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const hu_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const nl_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const nb_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const pl_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const pt_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const ro_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const sk_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const sl_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const fi_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const sv_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const vi_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const tr_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const el_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const bg_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const ru_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const sr_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const uk_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const ka_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const hi_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const th_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const ko_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const zh_tw_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const ja_origin_display_name = /** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

/** @type {(inputs: Origin_Display_NameInputs) => LocalizedString} */
const zh_origin_display_name = en_origin_display_name;

/**
* | output |
* | --- |
* | "Brave Origin" |
*
* @param {Origin_Display_NameInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const origin_display_name = /** @type {((inputs?: Origin_Display_NameInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Origin_Display_NameInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_origin_display_name(inputs)
	if (locale === "ms") return ms_origin_display_name(inputs)
	if (locale === "ca") return ca_origin_display_name(inputs)
	if (locale === "cs") return cs_origin_display_name(inputs)
	if (locale === "da") return da_origin_display_name(inputs)
	if (locale === "de") return de_origin_display_name(inputs)
	if (locale === "et") return et_origin_display_name(inputs)
	if (locale === "es") return es_origin_display_name(inputs)
	if (locale === "fr") return fr_origin_display_name(inputs)
	if (locale === "hr") return hr_origin_display_name(inputs)
	if (locale === "it") return it_origin_display_name(inputs)
	if (locale === "lv") return lv_origin_display_name(inputs)
	if (locale === "lt") return lt_origin_display_name(inputs)
	if (locale === "hu") return hu_origin_display_name(inputs)
	if (locale === "nl") return nl_origin_display_name(inputs)
	if (locale === "nb") return nb_origin_display_name(inputs)
	if (locale === "pl") return pl_origin_display_name(inputs)
	if (locale === "pt") return pt_origin_display_name(inputs)
	if (locale === "ro") return ro_origin_display_name(inputs)
	if (locale === "sk") return sk_origin_display_name(inputs)
	if (locale === "sl") return sl_origin_display_name(inputs)
	if (locale === "fi") return fi_origin_display_name(inputs)
	if (locale === "sv") return sv_origin_display_name(inputs)
	if (locale === "vi") return vi_origin_display_name(inputs)
	if (locale === "tr") return tr_origin_display_name(inputs)
	if (locale === "el") return el_origin_display_name(inputs)
	if (locale === "bg") return bg_origin_display_name(inputs)
	if (locale === "ru") return ru_origin_display_name(inputs)
	if (locale === "sr") return sr_origin_display_name(inputs)
	if (locale === "uk") return uk_origin_display_name(inputs)
	if (locale === "ka") return ka_origin_display_name(inputs)
	if (locale === "hi") return hi_origin_display_name(inputs)
	if (locale === "th") return th_origin_display_name(inputs)
	if (locale === "ko") return ko_origin_display_name(inputs)
	if (locale === "zh") return zh_origin_display_name(inputs)
	if (locale === "zh-tw") return zh_tw_origin_display_name(inputs)
	if (locale === "ja") return ja_origin_display_name(inputs)
	return en_origin_display_name(inputs)
});